import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Button, Pagination, CircularProgress, Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import { client } from '../api/Api';

const PricesAdminList = () => {
  const [page, setPage] = useState(1);
  const [size] = useState(20);
  const [data, setData] = useState({ content: [], totalElements: 0, totalPages: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = async (p) => {
    setLoading(true);
    setError(null);
    try {
      const res = await client.get(`/admin/prices?page=${p - 1}&size=${size}`);
      setData(res.data);
    } catch (e) {
      setError('Nepavyko užkrauti kainų sąrašo');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
      <Typography variant="h4" sx={{ mb: 2 }}>Kainos</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Produktas</TableCell>
                  <TableCell>Tiekėjas</TableCell>
                  <TableCell>Kaina</TableCell>
                  <TableCell>Data</TableCell>
                  <TableCell align="right">Veiksmai</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.content?.map((r) => (
                  <TableRow key={r.id} hover>
                    <TableCell>{r.id}</TableCell>
                    <TableCell>{r.productName || '-'}</TableCell>
                    <TableCell>{r.providerName || '-'}</TableCell>
                    <TableCell>{r.value != null ? Number(r.value).toFixed(2) : '-'}</TableCell>
                    <TableCell>{r.date || '-'}</TableCell>
                    <TableCell align="right">
                      <Button component={Link} to={`/admin/prices/${r.id}`} size="small" variant="contained">Redaguoti</Button>
                    </TableCell>
                  </TableRow>
                ))}
                {(!data.content || data.content.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">Įrašų nėra</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Box display="flex" justifyContent="center" py={2}>
            <Pagination
              count={data.totalPages || 0}
              page={page}
              onChange={(_, p) => setPage(p)}
              color="primary"
            />
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default PricesAdminList;
